import { AuditInvoiceSummaryDTO, NoteDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export const LoadAllAuditInvoiceSummaries = createAction(
    '[AuditInvoiceSummary] LoadAllAuditInvoiceSummaries',
    props<{ from?: string; to?: string }>()
);
export const LoadAllAuditInvoiceSummariesSuccess = createAction(
    '[AuditInvoiceSummary] LoadAllAuditInvoiceSummariesSuccess',
    props<{ auditInvoiceSummaries: AuditInvoiceSummaryDTO[] }>()
);
export const LoadAllAuditInvoiceSummariesFailure = createAction(
    '[AuditInvoiceSummary] LoadAllAuditInvoiceSummariesFailure',
    props<{ error: any }>()
);

export const LoadAuditInvoiceSummary = createAction(
    '[AuditInvoiceSummary] LoadAuditInvoiceSummary',
    props<{ auditInvoiceSummaryId: string }>()
);
export const LoadAuditInvoiceSummarySuccess = createAction(
    '[AuditInvoiceSummary] LoadAuditInvoiceSummarySuccess',
    props<{ auditInvoiceSummary: AuditInvoiceSummaryDTO }>()
);
export const LoadAuditInvoiceSummaryFailure = createAction('[AuditInvoiceSummary] LoadAuditInvoiceSummaryFailure', props<{ error: any }>());

export const CreateAuditInvoiceSummaryNote = createAction(
    '[AuditInvoiceSummary] CreateAuditInvoiceSummaryNote',
    props<{ auditInvoiceSummaryId: string; note: NoteDTO }>()
);
export const RemoveAuditInvoiceSummaryNote = createAction(
    '[AuditInvoiceSummary] RemoveAuditInvoiceSummaryNote',
    props<{ auditInvoiceSummaryId: string; noteId: string }>()
);
export const ApproveAuditInvoiceSummary = createAction(
    '[AuditInvoiceSummary] ApproveAuditInvoiceSummary',
    props<{ auditInvoiceSummaryId: string }>()
);
export const RejectAuditInvoiceSummary = createAction(
    '[AuditInvoiceSummary] RejectAuditInvoiceSummary',
    props<{ auditInvoiceSummaryId: string }>()
);
export const MarkAuditInvoiceSummaryDocumentAsRead = createAction(
    '[AuditInvoiceSummary] MarkAuditInvoiceSummaryDocumentAsRead',
    props<{ auditInvoiceSummaryId: string; documentDescriptionId: string }>()
);

export const AuditInvoiceSummaryActionSuccess = createAction(
    '[AuditInvoiceSummary] AuditInvoiceSummaryActionSuccess',
    props<{ auditInvoiceSummaryId: string }>()
);
export const AuditInvoiceSummaryActionFailure = createAction(
    '[AuditInvoiceSummary] AuditInvoiceSummaryActionFailure',
    props<{ auditInvoiceSummaryId: string; error: any }>()
);
